import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.URL,
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,
  totalOccurrences (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}totalOccurrences/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  answersByOccurrences (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}answersByOccurrences/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  answersByOccurrencesExcel (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}answersByOccurrencesExcel/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  }
}
